import { render } from "./ListUsers.vue?vue&type=template&id=4c8a89f6"
import script from "./ListUsers.vue?vue&type=script&lang=js"
export * from "./ListUsers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__